import { memo } from "react";
import { Outlet } from "react-router-dom";
import { Div, PageHolder, useBetterHtmlContext, useMediaQuery, useTheme } from "react-better-html";

import LegalHeader from "../../components/structure/headers/LegalHeader";
import Footer from "../../components/structure/Footer";

function LegalRoot() {
   const theme = useTheme();
   const mediaQuery = useMediaQuery();
   const { app } = useBetterHtmlContext();

   return (
      <>
         <LegalHeader />

         <PageHolder.center
            contentMaxWidth={app.contentMaxWidth}
            padding={theme.styles.space * (mediaQuery.size600 ? 1 : 2)}
         >
            <Div width="100%" overflowX="hidden">
               <Outlet />
            </Div>
         </PageHolder.center>

         <Div padding={theme.styles.space}>
            <Footer />
         </Div>
      </>
   );
}

export default memo(LegalRoot);
